var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57913 9.08418L5.15101 9.3698C4.73632 9.45274 4.37587 9.70676 4.15829 10.0694C3.44528 11.2577 3.44528 12.7423 4.15829 13.9307C4.37587 14.2933 4.73633 14.5473 5.15101 14.6302L6.84404 14.9688C6.9449 14.989 7.03582 15.0431 7.10167 15.1221L9.17076 17.605C10.3533 19.0241 10.9446 19.7336 11.4723 19.5426C11.9999 19.3516 11.9999 18.428 11.9999 16.5807V13.5194L6.57913 9.08418ZM11.9999 9.08669V7.4193C11.9999 5.57209 11.9999 4.64848 11.4722 4.45744C10.9446 4.26641 10.3533 4.97594 9.17076 6.395L8.98399 6.61912L11.9999 9.08669Z",
    fill: "#C6C6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8993 13.0951C17.0222 12.4333 17.0336 11.7515 16.9289 11.0781C16.7333 9.82037 16.1428 8.65741 15.2428 7.75737C14.8522 7.36685 14.2191 7.36685 13.8285 7.75737C13.438 8.1479 13.438 8.78106 13.8285 9.17158C14.4286 9.77161 14.8222 10.5469 14.9526 11.3854C14.9594 11.4293 14.9655 11.4733 14.9709 11.5173L16.8993 13.0951Z",
    fill: "#C6C6C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8784 16.3509C21.6134 15.0197 22.0059 13.5118 21.9998 11.9645C21.9905 9.58989 21.043 7.31517 19.3638 5.63603C18.9733 5.24551 18.3402 5.24551 17.9496 5.63603C17.5591 6.02656 17.5591 6.65972 17.9496 7.05025C19.2556 8.35625 19.9926 10.1255 19.9998 11.9724C20.0041 13.0508 19.7594 14.1047 19.2971 15.0571L20.8784 16.3509Z",
    fill: "#C6C6C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14795 5L21.2591 19",
    stroke: "#C6C6C6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/muted.132864fc14d6380f75585fad9c520cc7.svg";
export { ForwardRef as ReactComponent };